import { combineObjectWithoutCloning } from "@helpers/_functions";
import moment from "moment-timezone";

export const reimbursmentsReducer = {
  initialState: {
    reimbursments: [],
    employerLists: [],
    enterpiseLists: [],
    isEnterpriseDataOutdated: false,
    isEnterpriseRefreshing: false,
    resourceStatus: {
      categories: {},
      taxes: {},
      accounts: {},
      employer: {},
      enterprise: {}
    },
    exportLists: [],
    categories: {
      isLoaded: false,
      data: []
    },
    accounts: {
      isLoaded: false,
      data: []
    },
    taxes:[],
    employerFilter: {
      period: {
        startDate: moment().subtract(3, "month").toDate(),
        endDate: moment().endOf("day").toDate(),
        timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    },
    enterpriseFilter: {
      period: {
        startDate: moment().subtract(3, "month").toDate(),
        endDate: moment().endOf("day").toDate(),
        timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    },
    exportFilter: {
      period: {
        startDate: moment().subtract(3, "month").toDate(),
        endDate: moment().endOf("day").toDate(),
        timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    },
    recentItineraries: [],
    itineraries: []
  },
  handlers: {
    "reimbursments/SET_RESOURCE_STATUS": (state, { resource, status }) =>
      combineObjectWithoutCloning(state, {
        resourceStatus: {
          ...state.resourceStatus,
          [resource]: { ...state.resourceStatus[resource], ...status }
        },
        ...(resource === "enterprise" && {
          isEnterpriseDataOutdated: status.isDataOutdated ?? state.isEnterpriseDataOutdated,
          isEnterpriseRefreshing: status.isRefreshing ?? state.isEnterpriseRefreshing
        })
      }),
    "reimbursments/SET_LISTS": (state, payload) =>
      combineObjectWithoutCloning(state, { reimbursments: payload }),
    "reimbursments/SET_EMPLOYER_FILTER": (state, payload) =>
      combineObjectWithoutCloning(state, { employerFilter: payload }),
    "reimbursments/SET_ENTERPRISE_FILTER": (state, payload) =>
      combineObjectWithoutCloning(state, { enterpriseFilter: payload }),
    "reimbursments/SET_EXPORT_FILTER": (state, payload) =>
      combineObjectWithoutCloning(state, { exportFilter: payload }),
    "reimbursments/SET_CATEGORIES": (state, payload) =>
      combineObjectWithoutCloning(state, { categories: payload }),
    "reimbursments/SET_ACCOUNTS": (state, payload) =>
      combineObjectWithoutCloning(state, { accounts: payload }),
    "reimbursments/SET_TAXES": (state, payload) =>
      combineObjectWithoutCloning(state, { taxes: payload }),
    "reimbursments/SET_EMPLOYER_LISTS": (state, payload) =>
      combineObjectWithoutCloning(state, { employerLists: payload }),
    "reimbursments/SET_ENTERPRISE_LISTS": (state, payload) =>
      combineObjectWithoutCloning(state, { enterpiseLists: payload }),
    "reimbursments/SET_ENTERPRISE_DATA_OUTDATED": (state, payload) =>
      combineObjectWithoutCloning(state, {
        isEnterpriseDataOutdated: payload
      }),
    "reimbursments/SET_ENTERPRISE_REFRESHING": (state, payload) =>
      combineObjectWithoutCloning(state, { isEnterpriseRefreshing: payload }),
    "reimbursments/SET_EXPORT_LISTS": (state, payload) =>
      combineObjectWithoutCloning(state, { exportLists: payload }),
    "reimbursments/SET_RECENT_ITINERARIES": (state, payload) =>
      combineObjectWithoutCloning(state, { recentItineraries: payload }),
    "reimbursments/SET_ITINERARIES_LISTS": (state, payload) =>
      combineObjectWithoutCloning(state, { itineraries: payload }),
    "recruitments/RESET_ALL": () => reimbursmentsReducer.initialState,
    "RESET_ALL": () => reimbursmentsReducer.initialState
  }
};

export default reimbursmentsReducer;
